
import { Options, Vue } from 'vue-class-component'
import AdminSubNavbar from '@/components/admin/layout/AdminSubNavbar.vue'
import AccountStatement from '@/components/admin/account-statement/AccountStatementReport.vue'
import LastTrades from '@/components/admin/dashboard/lastTrades.vue'
import { namespace } from 'vuex-class'
const dashboard = namespace('dashboard')

@Options({
  components: {
    LastTrades,
    AdminSubNavbar,
    AccountStatement
  }
})
export default class DashboardBase extends Vue {
  @dashboard.Getter
  // eslint-disable-next-line
  cards!: any
  show = false
  @dashboard.Action
  // eslint-disable-next-line
  public getCards!: () => Promise<any>

  async mounted() {
    try {
      // eslint-disable-next-line
      ;(this as any).$store.dispatch('loader/show')
      await this.getCards()
    } catch (error) {
      //toast.error(error);
    }
  }

  moveTo(path: string) {
    // eslint-disable-next-line
    ;(window as any).router = this.$router
    if (this.$route.path == path) {
      this.$router.push({ path: '/dashboard' })
    } else {
      this.$router.push({ path })
    }
  }

  showToggle() {
    this.show = !this.show
  }
}
